import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import TopNav from "../components/TopNav";
import BackButton from "../components/BackButton";
import "./ChartersViewPage.css";


const ChartersViewPage = (props) => {
    const navigate = useNavigate();  // Add this line
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [charterData, setCharterData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);

    useEffect(() => {
        const storedData = localStorage.getItem("charterData");
        if (storedData) {
            setCharterData(JSON.parse(storedData));
            // getData();
        } else {
            getData();
        }

        return () => {}
    }, []);

    const getData = async () => {
        setLoading(true);
        setError(null);
        
        
        try {
            const { data } = await axios.get("/api/charters/view", {
                params: {
                    page: "view",
                    _t: Date.now(),
                },
            });
            
            if (data) {
                console.log(data);
                setCharterData(data);
                localStorage.setItem("charterData", JSON.stringify(data));
            } else {
                console.log("No data");
                setError("No charter data available.");
                setCharterData([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setError("Failed to fetch charter data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleRefresh = async () => {
        setRefreshing(true);
        setError(null);
        
        try {
            await getData();
        } finally {
            setRefreshing(false);
        }
    };
    const handleManage = () => {
        navigate('/charter-manage');
    };    

    return (
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />
            <BackButton />
            <div className={`charter-container ${props.darkmode ? "dark-theme" : "light-theme"}`}>
                {/* Header Section */}
                <div className="charter-header-section">
                    <div className="charter-title-group">
                        <h1>
                            {/* <span className="charter-icon"></span> */}
                            Charter Flights
                        </h1>
                        <div className="charter-subtitle">
                            {charterData && <div>{charterData.length} available (plus return legs).</div>}
                        </div>
                    </div>
                    <div className="button-group">
                        {props.charterCert > 0 &&
                            <button
                                className="btn btn-charter-new"
                                onClick={handleManage}
                            >
                            <span>Manage</span>
                            </button>
                        }
                        <button
                            className="btn btn-refresh"
                            onClick={handleRefresh}
                            disabled={refreshing || loading}
                        >
                            {refreshing ? (
                                <>
                                    <span className="loading-spinner"></span>
                                    Refreshing...
                                </>
                            ) : (
                                <>
                                    <span>Refresh</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>

                {/* Error Message */}
                {error && (
                    <div className="charter-card">
                        <div className="info-box error">
                            <strong>Error:</strong> {error}
                        </div>
                    </div>
                )}

                {/* Loading State */}
                {loading && !charterData && (
                    <div className="charter-card">
                        <div className="loading-container">
                            <span className="loading-spinner"></span>
                            <p>Loading charter flights...</p>
                        </div>
                    </div>
                )}

                {/* Charter Flights List */}
                {charterData && charterData.length === 0 && !loading && (
                    <div className="charter-card">
                        <div className="info-box warning">
                            <strong>No charters available.</strong> There are currently no charter flights in the system.
                        </div>
                    </div>
                )}

                {charterData && charterData.length > 0 && (
                    <div className="charter-stats">
                        <div className="stat-box">
                            <span className="stat-label">
                            Charter Flights are additional routes that can be flown by any member. 
                            These routes were created by Charter Captains, who want to share a favorite
                            flight that is not on the system schedule, or by FDXVA to support operations, 
                            such as certification and events. Both the outbound leg and the inbound, or 
                            return leg, are authorized.

                            </span>
                        </div>
                    </div>
                )}

                {charterData && charterData.map((chdata, index) => (
                    <div key={index} className="charter-card">
                        <div className="charter-route-header">
                            <div className="route-title">
                                <span className="route-icon">🛫</span>
                                <h2>{chdata.origin_city} → {chdata.dest_city}</h2>
                                <span className="distance-badge">{chdata.distance_nm} nm</span>
                            </div>
                            {chdata.count > 0 && (
                                <div className="usage-badge">
                                    {/* <span className="badge-icon">🔥</span> */}
                                    {chdata.count} flight{chdata.count > 1 ? 's' : ''}
                                </div>
                            )}
                        </div>

                        <div className="charter-details">
                            <div className="detail-section">
                                <div className="detail-item">
                                    <span className="detail-label">
                                        <span className="detail-icon">🛫</span>
                                        Origin
                                    </span>
                                    <span className="detail-value">
                                        <strong>{chdata.orig_code}</strong>
                                        <span className="detail-secondary">{chdata.origin_airport}</span>
                                    </span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">
                                        <span className="detail-icon">🛬</span>
                                        Destination
                                    </span>
                                    <span className="detail-value">
                                        <strong>{chdata.dest_code}</strong>
                                        <span className="detail-secondary">{chdata.dest_airport}</span>
                                    </span>
                                </div>
                            </div>

                            <div className="charter-meta">
                                <div className="meta-item">
                                    <span className="meta-icon">👤</span>
                                    <span className="meta-text">
                                        Created by <strong>{chdata.creator_name}, {chdata.creator_callsign}</strong> ( {chdata.rank} )
                                    </span>
                                </div>
                                <div className="meta-item">
                                    <span className="meta-icon">📅</span>
                                    <span className="meta-text">
                                        Created on <strong>{chdata.creation_date}</strong>
                                    </span>
                                </div>
                                {chdata.count > 0 && chdata.last_flown_date && (
                                    <div className="meta-item">
                                        <span className="meta-icon">🕒</span>
                                        <span className="meta-text">
                                            Last flown on <strong>{chdata.last_flown_date}</strong>
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="charter-actions">
                            <button 
                                className="btn btn-primary"
                                onClick={() => navigate('/routes', { state: { route: { orig: chdata.orig_code, dest: chdata.dest_code } } })}
                            >
                                <span>✈️</span>
                                Fly Route
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
}

export default ChartersViewPage;
